import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: "row",
    marginTop: 5,
    marginBottom: 5,
  },
  tableLeft: {
    width: "65%",
    marginRight: 5,
  },
  tableRight: {
    display: "table",
    width: "35%",
    borderStyle: "solid",
    // borderWidth: 1,
    borderLeftWidth: 0,
    marginLeft: 5,
  },
  tableRowRight: {
    flexDirection: "row",
  },
  tableColRightLeft: {
    width: "50%",
    borderStyle: "solid",
    borderRightWidth: 0,
    // borderLeftWidth: 1,
    // borderBottomWidth: 1,
    backgroundColor: "#F2F2F2",
  },
  tableColRight: {
    width: "50%",
    borderStyle: "solid",
    // borderLeftWidth: 1,
    // borderBottomWidth: 1,
  },
  tableCellRight: {
    fontSize: 9,
    textAlign: "center",
    paddingVertical: 4,
    paddingHorizontal: 2,
  },
});

const TotalVoucher = ({ invoice }) => {
  const parsedInvoice = JSON.parse(JSON.parse(JSON.stringify(invoice)));

  return (
    <Fragment>
      <View style={styles.titleContainer}>
        <View style={styles.tableLeft} />
        <View style={styles.tableRight}>
          <View style={styles.tableRowRight}>
            <View style={styles.tableColRightLeft}>
              <Text style={styles.tableCellRight}>Total</Text>
            </View>
            <View style={styles.tableColRight}>
              <Text style={styles.tableCellRight}>
                <b>&#8364; {parsedInvoice.booking_amount.toFixed(2)}</b>
              </Text>
            </View>
          </View>
        </View>
      </View>
    </Fragment>
  );
};

export default TotalVoucher;
